export const ESTORE_KEY = 'ESTORE'
export const MINISTORE_KEY = 'MINISTORE'
export const PID_KEY = 'PID'
export const MINISTORE_PID_KEY = 'MINISTORE_PID'
export const REDIRECT_URL_KEY = 'REDIRECT_URL'
export const MINISTORE_HOME = 'MINISTORE_HOME'
export const MINISTORE_SFC_REFERRAL_REWARDS_KEY = 'MINISTORE_SFC_REFERRAL_REWARDS'
export const MINISTORE_REFERRAL_PROGRAM_KEY = 'MINISTORE_REFERRAL_PROGRAM'

export const ESTORE_DEFAULT_STORE = 'DEFAULT_STORE'
export const CF_CHALLENGE_REDIRECT_URL = 'CF_CHALLENGE_REDIRECT_URL'

export const ATTRIBUTE_MAP = {
  loadBalancingAndFailover: 'Load Balancing and Failover',
  pepvpn: 'PEPVPN',
}

export const ATTRIBUTE_HIDDEN = ['customFields', 'awCpDisablePrice']

export const ENV = {
  PRODUCTION: 'production',
}

export const AUTH_PROVIDER_KEY = 'MINISTORE_AUTH_PROVIDER'
export const AUTH_PROVIDER = {
  TOKEN: 'token',
  SSO: 'sso',
}

export const CREDIT_CARDS = {
  AMERICAN_EXPRESS: 'American Express',
  MASTERCARD: 'MasterCard',
  VISA: 'Visa',
  UNION_PAY: 'UnionPay',
}


export const ENTITY = {
  PEPLINK: 'Peplink',
  PEPWAVE: 'Pepwave',
}

export const MODAL_SIZE = {
  sm: '350px',
  md: '500px',
  lg: '700px',
}

export const ROUTE = {
  HOME: '/',
  LOGIN: '/login',
  ACCOUNT: '/account',
  ACCOUNT_SETTINGS: '/account/settings',
  ACCOUNT_ADDRESS_BOOK: '/account/address-book',
  ACCOUNT_BOOKMARK: '/account/bookmark',
  ACCOUNT_QUOTATION: '/account/quotation',
  ACCOUNT_DOWNLOAD: '/account/download',
  ACCOUNT_DEVICE_MANAGEMENT: '/account/device-management',
  CART: '/cart',
  CATEGORIES: '/categories',
  CHALLENGE: '/challenge',
  CHECKOUT: '/checkout',
  CHECKOUT_CONFIRM_ORDER: '/checkout/confirm-order',
  CHECKOUT_PAYMENT: '/checkout/payment',
  CHECKOUT_THANK_YOU: '/checkout/thank-you',
  CO_TERM_CHECKOUT: '/co-term/checkout',
  CO_TERM_QUOTATIONS: '/co-term/quotations',
  CO_TERM_CREATE_QUOTATION: '/co-term/create-quotation',
  CO_TERM_QUOTATION_PRINT: '/co-term/quotation-detail/print',
  CO_TERM_QUOTATION_DETAILS: '/co-term/quotation-details',
  CO_TERM_SIMULATION: '/co-term/simulation',
  ORDER: '/order',
  QUICK_ORDER: '/quick-order',
  PRODUCTS: '/products',
  INCONTROL_CALLBACK: '/incontrol/callback',
  SSO_CALLBACK: '/sso/callback',
  SEARCH: '/search',
  PARTNER_PAVILLION_CHECKOUT: '/partner-pavillion/checkout',
  PARTNER_CHECKOUT: '/partners/checkout',
  PARTNER_CHECKOUT_THANK_YOU: '/partners/checkout/thank-you',
  QUOTATION_PAYMENT: '/quotation/payment',
  SN_REDIRECT: '/sn',
  SPEEDFUSION_CLOUD: '/speedfusioncloud',
  CHECK_LOGIN: '/check-login.html',
  MONITORING: '/monitoring',

  // MiniStore v1
  MOBILE: '/mobile',
  MOBILE_CHECKOUT: '/mobile/checkout',
  MOBILE_CHECKOUT_SUCCESS: '/mobile/checkout-success',
  MOBILE_PRODUCT_PLANS: '/mobile/product-plans',
  MOBILE_PRODUCT_PLANS_CART: '/mobile/product-plans/cart',
  MOBILE_PRODUCT_PLANS_CHECKOUT: '/mobile/product-plans/checkout',
  MOBILE_WARRANTIES: '/mobile/warranties',
  MOBILE_WARRANTIES_CART: '/mobile/warranties/cart',
  MOBILE_WARRANTIES_CHECKOUT: '/mobile/warranties/checkout',
  MOBILE_REFERRAL_REWARDS: '/mobile/referral-rewards',
  MOBILE_REFERRAL_REWARD_COUPONS: '/mobile/referral-reward-coupons',
  MOBILE_SFC_REFERRAL_REWARDS: '/mobile/sfc-referral-rewards',
  REFERRAL: '/m/referral',
  REFERRAL_SSO_CALLBACK: '/m/referral/sso/callback',
  REFERRAL_PRODUCTS: '/m/referral/products',
  REFERRAL_CART: '/m/referral/cart',
  REFERRAL_CHECKOUT: '/m/referral/checkout',
  REFERRAL_CHECKOUT_SUCCESS: '/m/referral/checkout-success',

  // MiniStore v2
  MINISTORE_V2_REFERRAL: '/m/v2/referral',
  MINISTORE_V2_REFERRAL_SSO_CALLBACK: '/m/v2/referral/sso/callback',
  MINISTORE_V2_REFERRAL_PRODUCTS: '/m/v2/referral/products',
  MINISTORE_V2_REFERRAL_CART: '/m/v2/referral/cart',
  MINISTORE_V2_REFERRAL_CHECKOUT: '/m/v2/referral/checkout',
  MINISTORE_V2_REFERRAL_CHECKOUT_SUCCESS: '/m/v2/referral/checkout-success',

  // SA public routes
  PUBLIC: '/public',
  PUBLIC_ORDERS_APPROVE: '/public/orders/approve',
  PUBLIC_ORDERS_REJECT: '/public/orders/reject',
  PUBLIC_ORDERS_SUCCESS: '/public/orders/s',
  PUBLIC_PAYMENT_SUCCESS: '/public/payment/:orderId/success',
  PUBLIC_PAYMENT: '/public/payment',
}

export const PRODUCT_SECTION = {
  specification: 'specification',
  packageContent: 'package-content',
  download: 'download',
  customOptions: 'custom-options',
}

export const ESTORE_PATH = 'estore'

export const PO_TYPES = [
  {
    label: 'Submit Purchase Order No.',
    value: 'poNumber',
  },
  {
    label: 'Upload Purchase Order',
    value: 'poUpload',
  },
  {
    label: 'Provide by Email Later',
    value: 'poEmail',
  },
]

export const ORDER_SOURCE = {
  SFC_APP_VPN: 'SFC_APP_VPN',
  STARLINK_PARTNER_PORTAL: 'STARLINK_PARTNER_PORTAL',
  COTERM_PARTNER_PAVILION: 'COTERM_PARTNER_PAVILION',
  COTERM: 'COTERM',
}

export const COTERM_STATUS = {
  ORDER_PROCESSING: { label: 'Order Processing', value: 'ORDER_PROCESSING' },
  CONVERTED: { label: 'Order Submitted', value: 'CONVERTED' },
  APPROVED_QUOTATION: { label: 'Pending Submission', value: 'APPROVED_QUOTATION' },
  CANCELLED: { label: 'Cancelled', value: 'CANCELLED' },
  DRAFT_ORDER: { label: 'Draft Order', value: 'DRAFT_ORDER' },
  SIMULATED: { label: 'Simulation Price', value: 'SIMULATED' },
}

export const SHIPPING_METHOD = {
  CUSTOMER_PROVIDED: 'Customer Provided',
  PRIORITY_SHIPPING: 'Priority Shipping',
}

export const SHIPPING_CARRIER = {
  US_VFT_ONLY_SELF_PICK_UP: 'US VFT Only - self pick-up',
}

export const PAYMENT_METHODS = {
  bank: 'Bank Transfer',
  creditTerm: 'Peplink Credit Terms Payment',
  cc: 'Credit Card',
  // paypal: 'Paypal',
  paypalPayment: 'Paypal Payment',
  na: 'Not Available',
}

export const PAYMENT_CONTEXT = {
  ESTORE: 'ESTORE',
  PARTNER: 'PARTNER',
  COTERM: 'COTERM',
}

export const ACCOUNT_LINKS_DOWNLOAD = {
  SHIPPING_INFORMATION: 'ShippingInformation',
  PRODUCT_LIST: 'ProductList',
}

export const CONFIGURABLE_ATTRIBUTES = ['size']
export const CONFIGURABLE_PRODUCT = 'configurable product'

export const ERROR_CODES = {
  MUST_CHANGE_STORE: 'must_change_store',
}

export const GENERIC_SERVER_ERROR =
  'The server encountered an error and could not complete your request. If the issue persists, please report to system administrator via "Report a bug" button on the page\'s right hand side. Thank you.'

export const SUBSCRIPTION_STATUS = {
  FAILED: 'FAILED',
}

export const REFERRAL_CODE = 'REFERRAL_CODE'
export const GET_REFERRAL_CODE = 'GET_REFERRAL_CODE'

export const SUBMITTING = 'SUBMITTING'

export const SSO_STATE = 'a9X3kP7wLt2ZqB5e'

export const SFC_MANAGEMENT = 'SFC Management'
export const SFC_CONNECTIVITY = 'Connectivity Usage Record'

export const PROMPT_CLEAR_CART = 'PROMPT_CLEAR_CART'
export const COTERM_QUOTATION_CONTEXT = 'COTERM_QUOTATION_CONTEXT'
export const COTERM_SIMULATION_CONTEXT = 'COTERM_SIMULATION_CONTEXT'

// ATTRIBUTES
// ==========================================================================
export const ATTRIBUTE_NAMES = {
  VIRTUAL_PRODUCT_TYPE: 'virtualProductType',
}

export const VIRTUAL_PRODUCT_TYPE = {
  DATA_PLAN_LICENSE: 'Data Plan License',
  CLOUD: 'Cloud',
  CLOUD_CONNECT: 'Cloud Connect',
  CLOUD_UNLIMITED: 'Cloud Unlimited',
}

export const PARTNER_PAVILLION = {
  QUOTATIONS_URL: `${process.env.REACT_APP_PEPLINK_PARTNER_PAVILLION_URL}/co-term-quotations`,
  QUOTATIONS_THANK_YOU_URL: `${process.env.REACT_APP_PEPLINK_PARTNER_PAVILLION_URL}/co-term-quotations/success/thanks`,
}

export const WARRANTY_TYPE = {
  ESSENTIAL_CARE: {
    code: 'EssentialCare',
    value: 'ESSENTIAL_CARE',
    label: 'EssentialCare',
  },
  ESSENTIAL_CARE_PLUS: {
    code: 'EssentialCare+',
    value: 'ESSENTIAL_CARE+',
    label: 'EssentialCare Plus',
  },
  PRIME_CARE: {
    code: 'PrimeCare',
    value: 'PRIME_CARE',
    label: 'PrimeCare',
  },
  PRIME_CARE_PLUS: {
    code: 'PrimeCare+',
    value: 'PRIME_CARE+',
    label: 'PrimeCare Plus',
  },
  IN_CONTROL: {
    code: 'InControl',
    value: 'IC_SUBSCRIPTION',
    label: 'InControl',
  },
  IN_CONTROL_2: {
    code: 'InControl',
    value: 'IC2_SUBSCRIPTION',
    label: 'InControl',
  },
}

export const REGION = {
  GLOBAL: 'Global',
  US: 'US',
}

export const MOBILE_PRODUCT_PLAN_TYPE = {
  CLOUD: 'cloud',
  CLOUD_CONNECT: 'cloud-connect',
  CLOUD_UNLIMITED: 'cloud-unlimited',
  LICENSE: 'license',
  ESIM: 'esim',
  ESIM_DATA: 'esim-data',
  ESIM_DATA_POOL: 'esim-data-pool',
}

export const HTTP_STATUS_CODES = {
  UNPROCESSABLE_ENTITY: 422,
}
